export default __webpack_public_path__ + "static/media/alimentacion_parenteral_pediatria.4089a240.pdf";